__webpack_require__.p = "https://static.age.awaze.com/search-mfe/2862f14/_next/";